import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { RowControlsRenderer } from "../../shared/components/AgGrid/RowControlsRenderer";
import { getDateFormatter, gridConfig } from "../../shared/constants/AgGrid/GridConfig";
import RequestSubTypeDetails from "./RequestSubTypeDetails/RequestSubTypeDetails";
import './RequestSubType.css';
import { getDateColumnConfig } from "../../shared/services/SharedService";
import RefreshIcon from '@material-ui/icons/Refresh';

export default function RequestSubType(props) {
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [activeRequestList, setActiveRequestList] = useState([]);
  const [documentRankings, setDocumentRankings] = useState([]);

  useEffect(() => {
    getActiveRequestList();
    getDocumentRankings();
    getRequestSubTypeList();
  }, []);

  const getRequestSubTypeList = async () => {
    try {
      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/requestType/getRequestSubTypes`
      );
      setRequestTypeList(response.data);
      props.setGridData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getActiveRequestList = async () => {
    try {
      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/requestType/getRequestTypes`
      );
      const data = response.data;
      setActiveRequestList(data?.length > 0 ? data.filter(d => d.active) : data);
    } catch (err) {
      console.log(err);
    }
  };

  const getDocumentRankings = async () => {
    try {
      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/documentRanking/getAllDocumentRanking`
      );
      setDocumentRankings(response.data ?? []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddClick = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(true);
  };

  const handleEditClick = (data) => {
    setSelectedData(data);
    setEdit(true);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(false);
  };

  const handleSave = () => {
    handleModalClose();
    getRequestSubTypeList(false);
  };

  const validationOnSave = (data, errorData) => {
    // Validation is now handled in the modal component itself
    // This function is kept for backwards compatibility but always returns true
    return true;
  };

  const gridRef = useRef(null);
  
  const gridOptions = {
    ...gridConfig,

    columnDefs: [
      { headerName: "Type", field: "requestTypeName",  sort: "asc", },
      { 
        headerName: "Sub Type", 
        field: "requestSubTypeName",
        valueGetter: (params) => {
          // If isRequestReasonCode is true and reasonCodeName exists, show reasonCodeName
          if (params.data?.isRequestReasonCode && params.data?.reasonCodeName) {
            return params.data.reasonCodeName;
          }
          // Otherwise show requestSubTypeName
          return params.data?.requestSubTypeName || '';
        }
      },
      { headerName: "Created By", field: "createdBy", },
      { headerName: "Updated By", field: "updatedBy", },
      {
        headerName: "Update At ",
        field: "updatedDate",
        ...getDateColumnConfig(),
      },
      { 
        headerName: "", 
        sortable: false,
        filter: false,
        cellRenderer: RowControlsRenderer, 
        cellRendererParams: {
          canEdit: true,
          onEditClick: handleEditClick,
        },
        maxWidth: 90,
      },
    ],
    
    dataTypeDefinitions: {
      ...gridConfig.dataTypeDefinitions,
      date: getDateFormatter("MM/DD/YYYY hh:mm:ss A"),
    },
  };
  
  useEffect(() => {
    props.setGridOptions(gridOptions);
  }, []);

  const onRefreshClick = () => {
    getActiveRequestList(true);
    getRequestSubTypeList(true);
    getDocumentRankings(true);
    props.gridRef.current.api.resetColumnState();
    props.gridRef.current.api.paginationGoToPage(0);
    
  }

  return (
    <>
    {
      props.gridRef?props.gridRef.current?props.gridRef.current.api?
      props.gridRef.current.api.paginationGoToPage(0):null:null:null
    }
      <div style={{ position: "absolute", top: "-50px", right: 0 }}>
        <Button
          variant="contained"
          onClick={handleAddClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          <Add />
          Add Subtype
        </Button>
      </div>


      <div style={{position: "absolute", top: "-50px", right: 200}}>
        <Button
          variant="contained"
          onClick={onRefreshClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          Refresh
          <RefreshIcon />
        </Button>
      </div>

      {requestTypeList?.length ? (     
        <></>
      ) : (<p className="error"> No records found. </p>)}

      {activeRequestList?.length ? (     
        <><RequestSubTypeDetails
          show={showModal}
          isEdit={isEdit}
          handleClose={handleModalClose}
          handleSave={handleSave}
          data={selectedData}
          handleValidation={validationOnSave}
          activeRequestList={activeRequestList}
          documentRankings={documentRankings}
          existingSubTypes={requestTypeList}
        /></>
      ) :<></>}
    </>
  );
}
